import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Beneficios() {
  const beneficios = [{
    icon: '🛡️',
    text: 'Entrar al taller con más seguridad'
  }, {
    icon: '📊',
    text: 'Detectar presupuestos inflados'
  }, {
    icon: '🗣️',
    text: 'Entender el chamuyo técnico'
  }, {
    icon: '✂️',
    text: 'Evitar reparaciones innecesarias'
  }, {
    icon: '🔩',
    text: 'Saber si un repuesto fue cambiado o no'
  }, {
    icon: '🏍️',
    text: 'Hacer services básicos de moto en casa'
  }, {
    icon: '💰',
    text: 'Ahorrar plata desde el primer service'
  }, {
    icon: '🚗',
    text: 'Cuidar mejor tu auto o moto'
  }, {
    icon: '🔍',
    text: 'Saber cuándo pedir otra opinión'
  }];
  return <section className="bg-mc-dark py-[72px] px-5" data-id="element-23">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-24">
        <FadeIn data-id="element-25">
          <SectionHeading centered data-id="element-26">
            Después de usar este pack{' '}
            <span className="text-mc-yellow" data-id="element-27">vas a poder…</span>
          </SectionHeading>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3.5 mt-9 text-left" data-id="element-28">
          {beneficios.map((ben, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-29">
              <div className="bg-mc-gray rounded-lg py-4 px-5 flex items-center gap-3.5 border-l-[3px] border-mc-yellow h-full" data-id="element-30">
                <div className="text-[1.5rem] shrink-0" data-id="element-31">{ben.icon}</div>
                <p className="text-[0.93rem] text-gray-200 font-semibold" data-id="element-32">
                  {ben.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}